import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ErrorMessage = function ({
  id, title, message, note, isWarning
}) {
  return (
    <span className={classnames(
      'messages',
      'error-messages',
    )}
    >
      <div
        className={classnames(
          'message',
          'error',
          'usa-alert',
          { 'usa-alert-error': !isWarning },
          { 'usa-alert-warning': isWarning }
        )}
        role="alert"
        aria-live="polite"
      >
        <div data-testid={id} className="usa-alert-body">
          <div data-i18n={id}>
            {title && (
            <h5 data-testid="title" className="usa-alert-heading">
              {title}
            </h5>
            )}
            {message && (
              Array.isArray(message) ? message.map((item, i) => <span data-testid="message" key={`${item}${i}`}>{item}<br /></span>) : <span data-testid="message">{message}</span>
            )}
            {note && <em data-testid="note">{note}</em>}
          </div>
        </div>
      </div>
    </span>
  );
};

ErrorMessage.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  message: [PropTypes.string, PropTypes.array],
  note: PropTypes.string,
  isWarning: PropTypes.bool,
};

ErrorMessage.defaultProps = {
  id: '',
  title: '',
  message: '',
  note: '',
  isWarning: false,
};

export default ErrorMessage;
